import styled from "@emotion/styled";
import { Select } from "@mui/material";

export const CustomStyledSelectField = styled(Select)(({ theme }) => ({
    '& .MuiInputBase-root':{
       fontSize:'13px'
    },
    '& .MuiInputBase-root.Mui-focused': {
        '& fieldset': {
            borderColor: process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY,
        },
    },
    '& .MuiInputBase-root.Mui-error': {
        '& fieldset': {
            borderColor: 'red',
        },
    },
}));
